module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "calendar-day",
    class: {
      'calendar-day-current': _vm.isCurrentMonth
    },
    on: {
      "click": _vm.clickDay
    }
  }, [_c('div', {
    staticClass: "calendar-day-date-box"
  }, [_c('div', {
    staticClass: "calendar-day-date"
  }, [_vm._v(_vm._s(_vm.day))])]), _c('vddl-list', {
    staticClass: "task-list",
    attrs: {
      "list": _vm.tasks,
      "drop": _vm.handleDrop,
      "horizontal": false
    }
  }, [_c('vddl-placeholder', {
    staticClass: "task-item"
  }, [_c('div', {
    staticClass: "task-item-box task-item-box__placeholder"
  }, [_vm._v("插入")])]), _vm._l((_vm.tasks), function(item, index) {
    return _c('vddl-draggable', {
      key: index,
      staticClass: "task-item",
      class: {
        'selected': _vm.selected === item
      },
      attrs: {
        "draggable": item,
        "index": index,
        "wrapper": _vm.tasks,
        "disable-if": !item.enable,
        "effect-allowed": "move",
        "selected": _vm.selectedEvent
      }
    }, [_c('div', {
      staticClass: "task-item-box",
      class: {
        'task-item-box__move': item.enable
      },
      style: (_vm._f("taskStyle")(item)),
      on: {
        "click": function($event) {
          _vm.clickTask(item)
        }
      }
    }, [_vm._v(_vm._s(item.label))])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1460c4b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar/CalendarDay.vue
// module id = 1697
// module chunks = 1